import { 
  DialogContent, DialogActions, Button, TextField, MenuItem, 
  Box, Typography, IconButton, Table, TableBody, TableCell, TableRow 
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useState, useEffect } from "react";

export default function SplitView({ row, rnrs, onBack, onClose, onSave }) {
  const [splits, setSplits] = useState([]);

  useEffect(() => {
    if (row.splits?.length) {
      setSplits(row.splits);
    } else {
      setSplits([{ rnr: "", amount: row.amount }]);
    }
  }, [row]);

  const totalAllocated = splits.reduce((sum, s) => sum + Number(s.amount || 0), 0);
  const remaining = (row.amount - totalAllocated).toFixed(2);
  const isBalanced = Math.abs(remaining) < 0.01;

  const updateRow = (index, field, value) => {
    setSplits(prev =>
      prev.map((s, i) =>
        i === index ? { ...s, [field]: value } : s
      )
    );
  };

  const handleSave = () => {
    const cleanedSplits = splits.map(s => ({
      ...s,
      amount: Number(s.amount)
    }));

    onSave(cleanedSplits);
  };

  return (
    <>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Jaota summa <b>{row.amount} {row.currency}</b> erinevate rahavoo ridade vahel.
        </Typography>
        
        <Table size="small">
          <TableBody>
            {splits.map((s, i) => (
              <TableRow key={i}>
                <TableCell sx={{ pl: 0 }}>
                  <TextField
                    select fullWidth size="small" label="RNR"
                    value={s.rnr} onChange={(e) => updateRow(i, "rnr", e.target.value)}
                  >
                    {rnrs.map(opt => <MenuItem key={opt.code} value={opt.code}>{opt.code} - {opt.description}</MenuItem>)}
                  </TextField>
                </TableCell>
                <TableCell width="140px">
                  <TextField
                    type="number" size="small" label="Summa"
                    value={s.amount} onChange={(e) => updateRow(i, "amount", e.target.value)}
                  />
                </TableCell>
                <TableCell width="40px" sx={{ pr: 0 }}>
                  <IconButton
                    onClick={() => setSplits(splits.filter((_, idx) => idx !== i))}
                    color="error"
                    disabled={splits.length === 1}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Button startIcon={<AddIcon />} onClick={() => setSplits([...splits, { rnr: "", amount: 0 }])} sx={{ mt: 2 }}>
          Lisa rida
        </Button>

        <Box sx={{ mt: 3, p: 2, bgcolor: isBalanced ? "#e8f5e9" : "#ffebee", borderRadius: 1 }}>
          <Typography variant="subtitle1" color={isBalanced ? "success.main" : "error.main"} align="right">
            {isBalanced ? "Summa on koos!" : `Jääk jaotada: ${remaining} ${row.currency}`}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button startIcon={<ArrowBackIcon />} onClick={onBack} sx={{ mr: 'auto' }}>Tagasi</Button>
        <Button onClick={onClose}>Tühista</Button>
        <Button 
          variant="contained" 
          disabled={!isBalanced || splits.some(s => !s.rnr)} 
          onClick={handleSave}
        >
          Salvesta jaotus
        </Button>
      </DialogActions>
    </>
  );
}